window.reInit = function () {
  for (var key in instant) {
    if (instant[key].init && cash.isFunction(instant[key].init)) {
      instant[key].init();
    }
  }

};

cash(function () {
  reInit();
});